import React, { useEffect, useState } from 'react';
import { departmentApi } from '@/features/workspace/api';

export const DepartmentStaffView: React.FC = () => {
  const [staff, setStaff] = useState<any[]>([]);
  const [, setLoading] = useState<boolean>(true);

  useEffect(() => {
    departmentApi
      .staff()
      .then(setStaff)
      .catch(() => setStaff([]))
      .finally(() => setLoading(false));
  }, []);

  const totalStaff = staff.length || 6;
  const supervisorsCount = staff.filter((s) => s.is_supervisor).length || 3;
  const avgLoad =
    staff.length > 0
      ? Math.round(staff.reduce((acc, s) => acc + s.workload_percent, 0) / staff.length)
      : 68;
  const dutiesCount =
    staff.filter((s) => s.duties_summary?.toLowerCase().includes('дежур')).length || 2;

  const getLoadColor = (load: number) => {
    if (load >= 85) return 'bg-amber-400 text-amber-300';
    if (load >= 70) return 'bg-cyan-400 text-cyan-300';
    return 'bg-emerald-400 text-emerald-300';
  };

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-cyan-500/20 bg-[#091b29]/80 p-6">
        <span className="text-[10px] font-bold uppercase tracking-wider text-cyan-400">
          Department Team
        </span>
        <h2 className="text-2xl font-bold text-white tracking-tight mt-1">
          Сотрудники и нагрузка
        </h2>
        <p className="text-xs sm:text-sm text-slate-400 mt-1 max-w-4xl">
          Новый внутренний раздел панели кафедры: состав, функции, нагрузка, научное руководство и ответственные. Одинаково доступен руководителю подразделения и лаборанту кафедры.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
          <div className="p-4 rounded-xl border border-cyan-500/20 bg-[#061420]/80">
            <span className="text-[11px] font-semibold uppercase text-slate-400">Сотрудники</span>
            <div className="text-3xl font-extrabold text-white mt-1">{totalStaff}</div>
            <span className="text-xs text-cyan-400 mt-1 block">в демонстрационной выборке</span>
          </div>

          <div className="p-4 rounded-xl border border-cyan-500/20 bg-[#061420]/80">
            <span className="text-[11px] font-semibold uppercase text-slate-400">Научные руководители</span>
            <div className="text-3xl font-extrabold text-white mt-1">{supervisorsCount}</div>
            <span className="text-xs text-cyan-400 mt-1 block">активные</span>
          </div>

          <div className="p-4 rounded-xl border border-cyan-500/20 bg-[#061420]/80">
            <span className="text-[11px] font-semibold uppercase text-slate-400">Средняя нагрузка</span>
            <div className="text-3xl font-extrabold text-white mt-1">{avgLoad}%</div>
            <span className="text-xs text-cyan-400 mt-1 block">по рабочим контурам</span>
          </div>

          <div className="p-4 rounded-xl border border-cyan-500/20 bg-[#061420]/80">
            <span className="text-[11px] font-semibold uppercase text-slate-400">Дежурства</span>
            <div className="text-3xl font-extrabold text-white mt-1">{dutiesCount}</div>
            <span className="text-xs text-cyan-400 mt-1 block">на текущую неделю</span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {staff.map((member) => {
          const loadColor = getLoadColor(member.workload_percent);
          return (
            <div
              key={member.id}
              className="p-5 rounded-2xl border border-cyan-500/20 bg-[#091b29]/90 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-xl bg-[#061420] border border-cyan-500/30 text-cyan-300 font-bold text-sm flex items-center justify-center shrink-0">
                    {member.initials}
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-sm font-bold text-white truncate">{member.full_name}</h3>
                    <p className="text-[11px] text-slate-400 truncate mt-0.5">{member.academic_title}</p>
                  </div>
                </div>

                <div className="mt-4">
                  <div className="w-full h-2 rounded-full bg-[#061420] overflow-hidden">
                    <div
                      className={`h-full rounded-full ${loadColor.split(' ')[0]}`}
                      style={{ width: `${member.workload_percent}%` }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex items-end justify-between mt-4 pt-3 border-t border-slate-800">
                <div>
                  <div className="text-base font-extrabold text-white font-mono">
                    {member.workload_percent}%
                  </div>
                  <span className="text-[10px] uppercase text-slate-400">нагрузка</span>
                </div>
                <div className="text-right">
                  <div className="text-xs font-semibold text-slate-300">{member.duties_summary}</div>
                  <span className="text-[10px] uppercase text-slate-500">контур</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
